import { Box } from "@mui/material";

import { usePclContext } from "../../context/PclContextProvider";

import PclHeaderText from "./PclHeaderText";

const titles = {
  Certified: "PRODUCT COMPLIANT LIST (PCL)",
  "In Progress": "PRODUCTS IN EVALUATION",
} as const;

const PclHeader = () => {
  const {
    filters: { status },
  } = usePclContext();

  const title = titles[status as keyof typeof titles] || "ARCHIVED PRODUCTS";

  return (
    <Box sx={{ marginX: 5, marginY: 2 }}>
      <h5 className="fw-bold">
        PRODUCTS
        <span className="text-primary"> - {title}</span>
      </h5>

      <PclHeaderText status={status} />
    </Box>
  );
};
export default PclHeader;
